import { render } from "./PaymentSuccessfulPage.vue?vue&type=template&id=7adecc5e"
import script from "./PaymentSuccessfulPage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessfulPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__